<ion-content>
  <div class="content-wrapper">
    <app-header></app-header>

    <div class="inner-content">
      <ion-header>
        <h1>Confirmation Page</h1>
      </ion-header>
      <div class="margin-top-l margin-left-m border-bottom-light-2">
        <br>
        <div class="margin-top-l margin-left-m">
          <ion-card>
            <ion-card-header>
              Thank you!
            </ion-card-header>

            <ion-card-content> 
              <p>Your registraton is complete, a confirmation email will be sent shortly from {{ eventSource | titlecase }}.</p>
            </ion-card-content>
          </ion-card>
          <br>
        </div>
        <div class="margin-top-l margin-left-m">
          <div class="button-wrapper">
            <a routerLink="/"><ion-button class="button">Home</ion-button></a>
          </div>
          <br>
        </div>
      </div>
    </div>
  </div>
</ion-content>
